<app-dialog [show]="show" [size]="'md'" [position]="'center'" [showHeader]="showHeader" (close)="onCancel()">
  <div class="flex flex-col items-center justify-center min-h-[250px] w-full px-4 py-6 sm:px-6 md:px-8">
    <div class="flex flex-col items-center">
      <div class="flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 mb-4">
        <i class="pi pi-comment text-3xl text-gray-400"></i>
      </div>
      <h2 class="text-lg sm:text-xl font-semibold text-center mb-2">Confirm SMS Resend</h2>
      <p class="text-center text-gray-700 mb-6">
        You are about to send a new verification SMS to <span class="font-semibold">{{ recipientName }}</span>. This will generate a new verification link.
      </p>
      <div class="flex justify-end w-full gap-2">
        <button type="button" (click)="onCancel()"
          class="h-10 w-24 rounded-lg bg-gray-100 hover:bg-gray-200 text-sm text-gray-700 transition-colors cursor-pointer">
          Cancel
        </button>
        <button type="button" (click)="onConfirm()"
          class="h-10 w-24 rounded-lg bg-black text-white hover:bg-gray-800 text-sm transition-colors duration-200 cursor-pointer">
          Confirm
        </button>
      </div>
    </div>
  </div>
</app-dialog> 